<template>
  <b-modal
    id="modal-contact-id"
    :title="$t('add_contacts')"
    cancel-variant="outline-secondary"
    :ok-title="$t('save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    size="lg"
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="infoContact">
      <b-form>
        <b-row>

          <b-col class="col-md-12">
            <b-form-group :label="$t('courses.type')">
              <validation-provider
                #default="{ errors }"
                :name="$t('courses.type')"
                rules="required"
              >
                <v-select
                  v-model="contact.type"
                  label="title"
                  :get-option-label="(el) => {return $t(el.title);}"
                  :reduce="(p) => p.id"
                  :options="contactTypes"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              :label="$t('company')"
              for="company"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('company')"
                rules="required"
              >
                <b-form-input
                  id="company"
                  v-model="contact.company_name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              :label="$t('inn')"
              for="inn"
            >
              <validation-provider
                #default="{ errors }"
                :name="$t('inn')"
                rules="required|length:9"
              >
                <b-form-input
                  id="inn"
                  v-model="contact.inn"
                  type="number"
                  on-key-press="if(this.value.length==9) return false;"
                  max="9"
                  :state="errors.length > 0 ? false:null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <span
                  v-if="contact && contact.inn && contact.inn.length"
                  :class="contact.inn.length === 9 ? 'text-dark' : 'text-danger'"
                  class="float-right"
                >
                  {{ contact.inn.length }}
                  <span class="text-dark">
                    /9
                  </span>
                </span>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-12">
            <b-form-group
              :label="$t('legal_address')"
              for="addressEntity"
            >
              <!-- <validation-provider
                #default="{ errors }"
                :name="$t('legal_address')"
                rules="required"
              > -->
                <b-form-input
                  id="addressEntity"
                  v-model="contact.address"
                />
                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
              <!-- </validation-provider> -->
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              label="E-mail"
              for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="E-mail"
                rules="email"
              >
                <b-form-input
                  id="email"
                  v-model="contact.email"
                  type="email"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col class="col-md-6">
            <b-form-group
              :label="$t('contact_number')"
              for="contactNumber"
            >
              <!-- <validation-provider
                #default="{ errors }"
                :name="$t('contact_number')"
                rules="required|length:12"
              > -->
                <!-- <b-form-input
                  id="contactNumber"
                  v-model="contact.phone_number"
                  on-key-press="if(this.value.length==12) return false;"
                  max="12"
                  type="number"
                /> -->
                <cleave
                  id="contactNumber"
                  class="form-control"
                  :raw="true"
                  :options="phoneOptions"
                  v-model="contact.phone_number"
                />
                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                <!-- <span
                  :class="contact.phone_number.length === 12 ? 'text-dark' : 'text-danger'"
                  class="float-right"
                >
                  {{ contact.phone_number.length }}
                  <span class="text-dark">/12</span>
                </span> -->
              <!-- </validation-provider> -->
            </b-form-group>
          </b-col>

          <b-col class="col-md-12">
            <b-form-group
              :label="$t('notes')"
              for="notes"
            >
              <!-- <validation-provider
                #default="{ errors }"
                :name="$t('notes')"
                rules="required"
              > -->
                <b-form-textarea
                  id="notes"
                  v-model="contact.description"
                  rows="3"
                />
                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
              <!-- </validation-provider> -->
            </b-form-group>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal,
  VBModal,
  BForm,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BFormTextarea,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { mapActions } from 'vuex'
import Cleave from "vue-cleave-component";
import vSelect from "vue-select";

export default {
  name: 'AddEditModal',
  components: {
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    Cleave,
    vSelect,
  },
  data() {
    return {
      email,
      required,
      contact: {
        type: '',
        company_name: '',
        inn: '',
        address: '',
        email: '',
        phone_number: '',
        description: '',
      },
      phoneOptions: {
        prefix: "998",
        blocks: [3, 2, 3, 2, 2],
        delimiter: " ",
      },
      contactTypes: [{title: 'provider', id: 'provider'}, {title: 'buyer', id: 'buyer'}]
    }
  },
  methods: {
    ...mapActions('contacts', ['CREATE_CONTACT', 'CREATE_AGENT', 'FETCH_ALL_CONTACTS_LIST']),

    showModal() {
      this.contact = {
        type: '',
        company_name: '',
        inn: '',
        address: '',
        email: '',
        phone_number: '',
        description: '',
      }
    },

    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.infoContact.validate()
        .then(success => {
          if (success) {
            if(this.contact.phone_number == '998'){
              this.contact.phone_number = ''
            }
            this.CREATE_CONTACT(this.contact)
              .then(res => {
                this.$_okToast()
                this.$bvModal.hide('modal-contact-id')
                this.FETCH_ALL_CONTACTS_LIST()
                this.$router.push(`/contacts/detail/${res.data.id}`)
              })
              .catch(err => {
                this.$_errToast(err)
              })
          }
        })
    },
  },
  directives: {
    'b-modal': VBModal,
  },
}
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

</style>